import React, { useEffect, useRef, useState } from "react"
import PropTypes from "prop-types"
import { withTranslation } from "react-i18next"
import { Select, ConfigProvider } from "antd"

const SelectVirtualRoom = props => {
  const [options, setOptions] = useState([])
  const [selectedValue, setSelectedValue] = useState(null)

  const abortRef = useRef(null)
  useEffect(() => {
    abortRef.current = new AbortController()
    return () => abortRef.current.abort()
  }, [])

  useEffect(() => {
    if (props.selection) setSelectedValue(props.selection)
    else setSelectedValue(null)
  }, [props.selection])

  useEffect(() => {
    setOptions([])
    if (props.data.length > 0) {
      let opts = []
      for (const entry of props.data) {
        let temp = new Object()
        temp.label = entry.vmr_number + " - " + entry.vmr_name
        temp.value = entry.vmr_id
        opts.push(temp)
      }
      opts.sort((a, b) => (a.label < b.label ? 1 : -1))
      setOptions(opts)
    }
  }, [props.data])

  const handleChange = newSelection => {
    setSelectedValue(newSelection)
    if (props.setSelectedRoom != null) {
      props.setSelectedRoom(newSelection)
    }
  }

  // Custom empty/Data not found dropdown
  const customizeRenderEmpty = () => (
    <div className="mt-3" style={{ textAlign: "center" }}>
      {props.loadingData
        ? <p>{props.t("Loading")}</p>
        : <p>{props.t("No rooms found")}</p>
      }
    </div>
  )

  return (
    <div>
      <ConfigProvider renderEmpty={customizeRenderEmpty}>
        <div className="config-provider">
          <Select
            showSearch
            loading={props.loadingData}
            placeholder={props.t("Select")}
            style={{ width: 100 + "%" }}
            value={selectedValue}
            onChange={handleChange}
            allowClear={true}
            options={options}
          />
        </div>
      </ConfigProvider>
    </div>
  )
}

SelectVirtualRoom.propTypes = {
  t: PropTypes.any,
  data: PropTypes.array,
  loadingData: PropTypes.bool,
  selection: PropTypes.string,
  setSelectedRoom: PropTypes.func,
}

export default withTranslation()(SelectVirtualRoom)